import SubscriptionPaymentDate
  from "%/dynamic-component-editor/standard-components/subscription-payment-card/SubscriptionPaymentDate.vue";
import SubscriptionPaymentAmount
  from "%/dynamic-component-editor/standard-components/subscription-payment-card/SubscriptionPaymentAmount.vue";
import SubscriptionPaymentStatus
  from "%/dynamic-component-editor/standard-components/subscription-payment-card/SubscriptionPaymentStatus.vue";
import SubscriptionPaymentPlanName
  from "%/dynamic-component-editor/standard-components/subscription-payment-card/SubscriptionPaymentPlanName.vue";
import SubscriptionPaymentBillingFrequency
  from "%/dynamic-component-editor/standard-components/subscription-payment-card/SubscriptionPaymentBillingFrequency.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacySubscriptionBillingHistory extends LegacyEntity {
  get elements() {
    return {
      SubscriptionPaymentDate,
      SubscriptionPaymentAmount,
      SubscriptionPaymentStatus,
      SubscriptionPaymentPlanName,
      SubscriptionPaymentBillingFrequency,
    };
  }
}
